import { render, staticRenderFns } from "./OrderDetailProductList.vue?vue&type=template&id=4f2eb2d0"
import script from "./OrderDetailProductList.vue?vue&type=script&lang=js"
export * from "./OrderDetailProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports